/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import '@splidejs/splide/css/core';

import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
	var splide = new Splide('.wp-block-tantrachair-tabs .splide', {
		type: 'fade',
		rewind: true,
		perPage: 1,
		drag: true,
		pagination: false,
		autoHeight: true,
		height: 'auto',
		arrows: false,
		easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
		dragMinThreshold: {
			mouse: 150,
			touch: 150,
		},
	});

	let resizeObserver;

	function setupHeightAdjustment() {
		const track = splide.root.querySelector('.splide__track');

		function updateHeight() {
			const activeSlide = splide.Components.Slides.getAt(splide.index).slide;
			const slideHeight = activeSlide.children[0].scrollHeight;
			track.style.transition = 'height 0.3s ease';
			track.style.height = slideHeight + 'px';
		}

		// Update on slide change
		splide.on('moved', updateHeight);

		// Update on mount
		splide.on('mounted', updateHeight);

		// Watch for content changes in slides
		if (window.ResizeObserver) {
			resizeObserver = new ResizeObserver(updateHeight);
			splide.Components.Slides.forEach(slideComponent => {
				resizeObserver.observe(slideComponent.slide);
			});
		}
	}

	splide.on('ready', setupHeightAdjustment);

	splide.mount();

	const paginationButtons = document.querySelectorAll('.tab-buttons .tab-button a');

	paginationButtons[0].parentElement.classList.add('active');

	paginationButtons.forEach((button, index) => {
		button.addEventListener('click', (e) => {
			if (e.target.parentElement.classList.contains('active')) {
				e.target.parentElement.parentElement.classList.toggle('dropdown-open');
				return;
			}

			e.target.parentElement.parentElement.classList.remove('dropdown-open');
			splide.go(index);
		});
	});

	splide.on('moved', (index) => {
		paginationButtons.forEach((button) => button.parentElement.classList.remove('active'));
		paginationButtons[index].parentElement.classList.add('active');
	});
});
